import { EntApi } from "../EntApi";
import { QueryAvailableLicensesOpts } from "../../model/entitlement/QueryAvailableLicensesOpts";
import { LicenseWithOwnerAndSingleUserAssignments } from "../../model/entitlement/LicenseWithOwnerAndSingleUserAssignments";
import * as EntClient from "../../gen/api/entitlement/entitlement-client";
import { handleApiCall } from "../util/ApiResponseUtil";

class RealEnt implements EntApi {
  initialize(initProvider: (name: string) => string): void {
    EntClient.defaults.baseUrl = initProvider("entApiBase");
    EntClient.defaults.headers = EntClient.defaults.headers || {};
    EntClient.defaults.headers["Authorization"] =
      "Bearer " + initProvider("accessToken");
    EntClient.defaults.cache = "no-cache";
  }

  getApiInfo(): Promise<{ version: string; [key: string]: any }> {
    return new Promise((resolve, reject) => {
      fetch(EntClient.defaults.baseUrl + "/openapi?info")
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(
              `Loading api information failed: ${response.status} (${response.statusText})`
            );
          }
        })
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  queryAvailableLicenses(
    userId: string,
    queryAvailableLicensesOpts?: QueryAvailableLicensesOpts
  ): Promise<LicenseWithOwnerAndSingleUserAssignments[]> {
    return handleApiCall(
      EntClient.queryAvailableLicenses(userId, queryAvailableLicensesOpts)
    );
  }
}

export default RealEnt;
